import { TaskType } from '@domain/tasks/models/Task';
import type { IconProps } from '@shared/icons';

export const orderWithinValueLabel = (days: number): string => {
  if (!Number.isFinite(days)) return '';
  const weeks = Math.round(days / 7);
  if (weeks < 0) {
    const late = Math.abs(weeks);
    return late === 1 ? '1 week late' : `${late} weeks late`;
  }
  if (weeks === 0) return 'Order now';
  if (weeks === 1) return '1 week';
  return `${weeks} weeks`;
};

export const orderShiftLabel = (days: number): string => {
  const weeks = Math.max(1, Math.round(Math.abs(days) / 7));
  const direction = days < 0 ? 'earlier' : 'later';
  return weeks === 1 ? `1 week ${direction}` : `${weeks} weeks ${direction}`;
};

export const taskIcon = (type: TaskType): IconProps['icon'] => {
  switch (type) {
    case TaskType.CONNECTION_UNAUTHORIZED:
      return 'LinkBroken';
    case TaskType.SHIPMENT_OVERDUE:
    case TaskType.SHIPMENT_INCOMING:
      return 'Boat';
    case TaskType.FORECAST_CHANGED:
      return 'Bag01';
    case TaskType.PRODUCTS_ADDED:
      return 'PackagePlus';
    case TaskType.REPLENISH:
      return 'Package02';
    default:
      return 'AnnotationCheck';
  }
};

export const taskIconTone = (
  type: TaskType,
): 'error' | 'warning' | 'secondary' | 'primary' => {
  switch (type) {
    case TaskType.CONNECTION_UNAUTHORIZED:
    case TaskType.SHIPMENT_OVERDUE:
      return 'error';
    case TaskType.REPLENISH:
      return 'warning';
    case TaskType.FORECAST_CHANGED:
      return 'secondary';
    default:
      return 'primary';
  }
};

export const taskPath = (type: TaskType): string => {
  switch (type) {
    case TaskType.CONNECTION_UNAUTHORIZED:
      return '/company';
    case TaskType.SHIPMENT_OVERDUE:
    case TaskType.SHIPMENT_INCOMING:
      return '/purchasing';
    case TaskType.PRODUCTS_ADDED:
      return '/product-catalog/products';
    case TaskType.FORECAST_CHANGED:
    case TaskType.REPLENISH:
    default:
      return '/inventory';
  }
};
